import { freedomApp, debug } from 'freedom-shared';

/**
 * Helper function to send Accelera (Kafka) events via JS Bridge
 */
export const sendAcceleraEvent = (
  eventName: string,
  params: Record<string, unknown> = {},
) => {
  debug(
    { prefix: 'Accelera Event', shouldLogInStageEnv: true },
    eventName,
    params,
  );

  if (typeof window.FreedomApp?.sendKafkaEvent !== 'function') {
    return;
  }

  freedomApp.lib.sendKafkaEvent({
    name: eventName,
    product: 'aviata',
    params,
    backup: null,
  });
};
